import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Port } from '@app/models';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';

import * as FileSaver from 'file-saver/FileSaver';

import * as PortActionTypes from "@core/actions/port.actions";

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class PortService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  get() {
    return this.http.get<Port[]>(`${API}ports`);
  }
  create(port: Port) {
    return this.http.post<Port>(`${API}ports`, port);
  }

  // TODO: CHANGE route?
  delete(PortId: number) {
    return this.http.delete<any>(`${API}ports/${PortId}`);
  }
  update(PortId: number, data: Port) {
    return this.http.put<Port>(`${API}ports/update/${PortId}`, data);
  }

  downloadPort() {
    return this.http.get(`${API}ports/export`, {
      responseType: 'blob',
      observe: 'response'
    }).subscribe(
      response => {
        const blob = response.body;
        FileSaver.saveAs(blob, 'Puertos.xlsx');
        this.store.dispatch(
          new PortActionTypes.ExportSuccess()
        );
      },
      err => {
        this.store.dispatch(new PortActionTypes.ExportFail(err));
      }
    )
  }
}
